"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[29184],{

/***/ 94526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49288);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n    background: unset !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  border: none;\n  cursor: auto;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var OptionsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-773c3636-0"
})(_templateObject());
var OptionRender = function(options) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(OptionsWrapper, {
        children: options
    });
};
var AutoComplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        filterOption: false,
        dropdownStyle: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            border: "1px solid ".concat(_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro),
            boxShadow: "unset",
            minWidth: "260px",
            width: "auto"
        }, props.dropdownStyles),
        dropdownRender: props.dropdownRender || OptionRender,
        width: props.width || "100%",
        bordered: props.bordered || false
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-773c3636-1"
})(_templateObject3(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var bordered = param.bordered;
    return bordered && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject1());
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (AutoComplete);


/***/ }),

/***/ 16368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33070);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    border-bottom: 0;\n    padding: 0;\n  }\n\n  .ant-modal-footer {\n    border-top: 0;\n    padding: 0;\n    text-align: unset;\n  }\n\n  .ant-modal-footer button + button {\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-content {\n    background: unset;\n    box-shadow: unset;\n  }\n\n  .ant-modal-header {\n    background: unset;\n    padding: unset;\n    border: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  height: 100vh;\n  top: unset;\n  background-color: ",
        ";\n  max-width: unset;\n  margin: unset;\n\n  .ant-modal-header {\n    border: unset;\n    padding: 0;\n  }\n\n  .ant-modal-content {\n    box-shadow: unset;\n    margin: auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .ant-modal-body {\n    height: 90%;\n    overflow-y: scroll;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-body {\n    padding: 0;\n  }\n\n  ",
        "\n\n  .ant-modal-content {\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var basicModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
var transparentModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
var fullscreenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
var modalTypes = {
    basic: basicModal,
    transparent: transparentModal,
    fullscreen: fullscreenModal
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(function(props) {
    return {
        footer: props.footer || false,
        type: props.type || "basic",
        radius: props.radius || "2px"
    };
}).withConfig({
    componentId: "sc-697a6696-0"
})(_templateObject3(), function(param) {
    var type = param.type;
    return modalTypes[type];
}, function(param) {
    var radius = param.radius;
    return radius;
}));


/***/ }),

/***/ 11913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84607);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 12px;\n      width: 12px;\n      font-size: 10px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      min-width: 38px;\n      height: 20px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  padding: 0;\n\n  height: 20px;\n  width: 20px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  cursor: pointer;\n\n  color: ",
        ";\n  font-weight: bold;\n  font-size: 12px;\n  line-height: 20px;\n\n  box-sizing: border-box;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-84f991d8-0"
})(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].chardonnay */ .Z.chardonnay + (0,_utils_hexOpacity__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(10), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].yellowSea */ .Z.yellowSea, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].yellowSea */ .Z.yellowSea, function(param) {
    var isSmall = param.isSmall;
    return isSmall && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject());
}, function(param) {
    var isUma = param.isUma;
    return isUma && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1());
});
/* harmony default export */ __webpack_exports__["Z"] = (Tag);


/***/ }),

/***/ 40892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dj": function() { return /* reexport */ Icons_ChevronRightSvg; },
  "V3": function() { return /* reexport */ Icons_DropDownSvg; },
  "iD": function() { return /* reexport */ Icons_LightningBoxSvg; },
  "SY": function() { return /* reexport */ Icons_LightningFilledSvg; },
  "Sf": function() { return /* reexport */ Icons_LightningSvg; },
  "bC": function() { return /* reexport */ Icons_TimerClockSvg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningSvg.tsx

var LightningSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1561_100863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5 1.25L6.75 5L9.75 6.125L4.5 11.75L5.25 8L2.25 6.875L7.5 1.25Z",
                    stroke: fill,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1561_100863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningSvg = (LightningSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningFilledSvg.tsx

var LightningFilledSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_118194)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.5 1L5 3.5L7 4.25L3.5 8L4 5.5L2 4.75L5.5 1Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_118194",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningFilledSvg = (LightningFilledSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningBoxSvg.tsx

var LightningBoxSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                stroke: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4016_142863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.75 3.625L10.125 6.75L12.625 7.6875L8.25 12.375L8.875 9.25L6.375 8.3125L10.75 3.625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4016_142863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white",
                        transform: "translate(4.5 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningBoxSvg = (LightningBoxSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/ChevronRightSvg.tsx

var ChevronRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_110905)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.51562 8.70331L7.21933 4.9996L3.51562 1.2959",
                    stroke: "#969696",
                    strokeOpacity: "0.6",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_110905",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ChevronRightSvg = (ChevronRightSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/DropDownSvg.tsx

var DropDownSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#00AB6B" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.5 6L8.5 10L12.5 6",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_DropDownSvg = (DropDownSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/TimerClockSvg.tsx

var TimerClockSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "6.00156",
                cy: "6.7252",
                r: "3.775",
                stroke: "#8277F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 4.5874V6.9624L7.1875 7.9124",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.60934",
                y1: "2.90025",
                x2: "3.457",
                y2: "1.42212",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "0.5",
                y1: "-0.5",
                x2: "2.86616",
                y2: "-0.5",
                transform: "matrix(-0.780869 -0.624695 -0.624695 0.780869 10.4688 3.60303)",
                stroke: "#8277F8",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_TimerClockSvg = (TimerClockSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/index.ts









/***/ }),

/***/ 51981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ InfoTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4303);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75818);







var InfoTable = function(_param) {
    var dataSource = _param.dataSource, _title = _param.title, title = _title === void 0 ? "" : _title, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "dataSource",
        "title"
    ]);
    if (!(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TableContainer */ .xJ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
        "data-cy": "trade-detail-modal-info-table-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                condition: title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                    "data-cy": "trade-detail-modal-info-table-title",
                    style: {
                        lineHeight: 0
                    },
                    children: title
                })
            }),
            dataSource.map(function(d, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: d.label,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .DataField */ .lg, {
                        "data-cy": "trade-detail-modal-info-table-item",
                        children: [
                            d.label,
                            " ",
                            d.value
                        ]
                    })
                }, (d === null || d === void 0 ? void 0 : d.key) || "dt-".concat(i));
            })
        ]
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (DetailModal)));


/***/ }),

/***/ 4303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DetailModal; }
});

// UNUSED EXPORTS: DetailModal

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts + 1 modules
var useEmittenInfoStore = __webpack_require__(97454);
// EXTERNAL MODULE: ./src/global/Securities/hooks/useLivePriceUpdater.ts
var useLivePriceUpdater = __webpack_require__(76870);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts + 1 modules
var styled = __webpack_require__(69836);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/styled.ts
var DetailModal_styled = __webpack_require__(75818);
;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/CompanyLabel.tsx








var CompanyLabel = function(param) {
    var notation = param.notation, corpAction = param.corpAction, indexes = param.indexes, tradeType = param.tradeType, dayTradeInfo = param.dayTradeInfo, tradingLimitInfo = param.tradingLimitInfo;
    var syariah = indexes.indexOf("JII") > -1 || indexes.indexOf("ISSI") > -1;
    var isAccel = tradeType === "ACCEL";
    var isDbx = indexes.indexOf("DBX") > -1;
    var isDayTrade = dayTradeInfo === null || dayTradeInfo === void 0 ? void 0 : dayTradeInfo.is_show_multiplier;
    var isTradingLimit = tradingLimitInfo.is_trading_limit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* CompanyLabelContainer */.gL, {
        align: "center",
        justify: "center",
        "data-cy": "trade-detail-modal-company-label=container",
        children: [
            notation.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/ic_indicator.svg",
                    alt: "warning",
                    width: "12px"
                })
            }),
            corpAction.active && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/corp_action_event_icon.svg",
                    alt: "corp_action"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDayTrade,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* LabelDayTrade */.$y, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/day-trade/lightning-filled-company.svg",
                            alt: "",
                            height: "14",
                            width: "14"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            size: "12px",
                            color: "#8277f8",
                            family: "bold",
                            children: [
                                dayTradeInfo.multiplier,
                                "x"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isTradingLimit,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TradingLimitBadge */.o7, {
                    children: tradingLimitInfo.haircut_percentage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isAccel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "Akselerasi"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDbx,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "DBX"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: syariah,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: color/* default.primary */.Z.primary,
                        children: "Syariah"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var DetailModal_CompanyLabel = (CompanyLabel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore.ts
var useBondPortfolioStore = __webpack_require__(29176);
;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/BondsCompany.tsx













var BondsCompany = function(param) {
    var showPrice = param.showPrice, symbol = param.symbol, iconUrl = param.iconUrl, bondsName = param.bondsName, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return [
            s.product
        ];
    }), 1), product = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanyCard */.SQ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/symbol/".concat(symbol),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                as: "a",
                justify: "space-between",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        width: showPrice ? "320px" : "100%",
                        "data-cy": "trade-detail-modal-bond-company-show-price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: iconUrl || constants/* FALLBACK_AVATAR_SRC */.sW,
                                style: {
                                    width: "40px",
                                    height: "40px",
                                    background: "white"
                                },
                                "data-cy": "trade-detail-modal-company-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                pl: "15px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            children: symbol
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: color/* default.midgray */.Z.midgray,
                                        // @ts-expect-error
                                        mr: "5px",
                                        mt: "3px",
                                        ellipsis: true,
                                        children: bondsName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showBondPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            pr: "8px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    align: "right",
                                    width: "80px",
                                    children: (0,number/* formatPercentage */.rl)(product === null || product === void 0 ? void 0 : (ref = product.meta) === null || ref === void 0 ? void 0 : ref.sell_price_rate, false, "0,0.00", true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "#969696",
                                    size: "14px",
                                    align: "right",
                                    width: "80px",
                                    children: "Harga Jual"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightSvg */.dj, {})
                ]
            })
        })
    });
};
/* harmony default export */ var DetailModal_BondsCompany = (BondsCompany);

;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/Company.tsx

















var CompanyContainer = function(param) {
    var children = param.children, href = param.href, onClick = param.onClick;
    return onClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanyButton */.R, {
        onClick: onClick,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: children
    });
};
var Company = function(param) {
    var symbol = param.symbol, showPrice = param.showPrice, isBonds = param.isBonds, _isRedemption = param.isRedemption, isRedemption = _isRedemption === void 0 ? false : _isRedemption, bondsName = param.bondsName, onClick = param.onClick, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var ref = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        return {
            data: s.data,
            isLoading: s.isLoading,
            loadEmittenInfo: s.loadEmittenInfo,
            resetEmittenInfo: s.resetEmittenInfo,
            updateEmittenInfo: s.updateEmittenInfo
        };
    }, shallow/* default */.Z), emittenInfo = ref.data, isLoading = ref.isLoading, loadEmittenInfo = ref.loadEmittenInfo, resetEmittenInfo = ref.resetEmittenInfo, updateEmittenInfo = ref.updateEmittenInfo;
    var name = emittenInfo.name, icon_url = emittenInfo.icon_url, formatted_price = emittenInfo.formatted_price, change = emittenInfo.change, percentage = emittenInfo.percentage, notation = emittenInfo.notation, corpAction = emittenInfo.corp_action, indexes = emittenInfo.indexes, tradeType = emittenInfo.trade_type, dayTradeInfo = emittenInfo.day_trade_info, tradingLimitInfo = emittenInfo.trading_limit_info;
    var isEmittenEmpty = (0,react.useMemo)(function() {
        return Object.keys(emittenInfo).length === 0;
    }, [
        JSON.stringify(emittenInfo)
    ]);
    (0,useLivePriceUpdater/* default */.Z)({
        symbol: symbol,
        page: "orderlist_detail"
    }, function(param) {
        var lastprice = param.lastprice, liveChange = param.change, percentage_change = param.percentage_change;
        updateEmittenInfo({
            formatted_price: lastprice.toString(),
            change: liveChange.toString(),
            percentage: percentage_change
        });
    });
    (0,react.useEffect)(function() {
        if (symbol && !isRedemption) loadEmittenInfo(symbol);
        return function() {
            resetEmittenInfo();
        };
    }, [
        symbol,
        isRedemption
    ]);
    if (isBonds || isRedemption) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_BondsCompany, {
            symbol: symbol,
            iconUrl: icon_url,
            showPrice: showPrice,
            bondsName: bondsName,
            showBondPrice: showBondPrice
        });
    }
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanySkeletonBlock */.eT, {});
    if (isEmittenEmpty) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyContainer, {
        href: "/symbol/".concat(symbol),
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* CompanyCard */.SQ, {
            as: "a",
            "data-cy": "trade-detail-modal-company-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                align: "center",
                width: "100%",
                "data-cy": "trade-detail-modal-company-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        align: "center",
                        width: showPrice ? "320px" : "100%",
                        children: [
                            !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* SymbolAvatar */.Mu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "white",
                                    family: "bold",
                                    size: "16px",
                                    children: symbol[0]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: icon_url,
                                style: {
                                    width: "40px",
                                    height: "40px",
                                    background: "white"
                                },
                                "data-cy": "trade-detail-modal-company-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                direction: "column",
                                // @ts-expect-error
                                pl: "15px",
                                "data-cy": "trade-detail-modal-company-info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: "bold",
                                                children: symbol
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_CompanyLabel, {
                                                notation: notation,
                                                corpAction: corpAction,
                                                indexes: indexes,
                                                tradeType: tradeType,
                                                dayTradeInfo: dayTradeInfo,
                                                tradingLimitInfo: tradingLimitInfo
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        size: "12px",
                                        color: color/* default.midgray */.Z.midgray,
                                        // @ts-expect-error
                                        mr: "5px",
                                        mt: "3px",
                                        ellipsis: true,
                                        children: name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    as: "div",
                                    family: "bold",
                                    align: "right",
                                    children: formatted_price
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    align: "right",
                                    // @ts-expect-error
                                    mt: "3px",
                                    color: (0,general/* getColorBasedOnNumber */.pV)(change),
                                    children: [
                                        Number(change) > 0 ? "+" : "",
                                        (0,number/* formatNumber */.uf)(change, false),
                                        " (",
                                        (0,number/* formatPercentage */.rl)(percentage, false),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !showPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-trading_back reverse"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var DetailModal_Company = (Company);

;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/index.tsx





var DetailModal = function(param) {
    var visible = param.visible, onCancel = param.onCancel, title = param.title, symbol = param.symbol, children = param.children, prefix = param.prefix, suffix = param.suffix, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds, _isRedemption = param.isRedemption, isRedemption = _isRedemption === void 0 ? false : _isRedemption, _bondsName = param.bondsName, bondsName = _bondsName === void 0 ? "" : _bondsName, onCompanyClick = param.onCompanyClick, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var onClose = function() {
        onCancel();
    };
    var isCompanyInfoVisible = function() {
        if (title === "WITHDRAW") return false;
        return !!symbol;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* Modal */.u_, {
        visible: visible,
        onCancel: onClose,
        centered: true,
        width: 520,
        "data-cy": "trade-detail-modal-container",
        zIndex: 1000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* ModalContent */.hz, {
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_styled/* HeaderWrapper */.Pz, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        align: "center",
                        family: "bold",
                        size: "18px",
                        "data-cy": "trade-detail-modal-title",
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailModal_styled/* ContentWrapper */.vs, {
                    children: [
                        prefix,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isCompanyInfoVisible(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_Company, {
                                symbol: symbol,
                                showPrice: showPrice,
                                isBonds: isBonds,
                                isRedemption: isRedemption,
                                bondsName: bondsName,
                                onClick: onCompanyClick,
                                showBondPrice: showBondPrice
                            })
                        }),
                        children
                    ]
                }),
                suffix
            ]
        })
    });
};
/* harmony default export */ var components_DetailModal = (DetailModal);


/***/ }),

/***/ 75818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ LabelDayTrade; },
/* harmony export */   "Mu": function() { return /* binding */ SymbolAvatar; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "R": function() { return /* binding */ CompanyButton; },
/* harmony export */   "SQ": function() { return /* binding */ CompanyCard; },
/* harmony export */   "eT": function() { return /* binding */ CompanySkeletonBlock; },
/* harmony export */   "gL": function() { return /* binding */ CompanyLabelContainer; },
/* harmony export */   "hz": function() { return /* binding */ ModalContent; },
/* harmony export */   "lg": function() { return /* binding */ DataField; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "ub": function() { return /* binding */ LabelWrapper; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "xJ": function() { return /* binding */ TableContainer; }
/* harmony export */ });
/* unused harmony exports BaseContainer, CompanyTextSkeleton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41080);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 19px;\n\n  &.border-bottom {\n    border-bottom: 1px solid #ededed;\n  }\n\n  .ant-progress-inner:not(.ant-progress-circle-gradient)\n    .ant-progress-circle-path {\n    stroke: ",
        ";\n  }\n\n  .free-transfer {\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 19px;\n    color: #00ab6b;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  row-gap: 14px;\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n\n  legend {\n    font-size: 14px;\n    font-family: var(--bold-font);\n    line-height: normal;\n    padding: 0 10px;\n    width: auto;\n    margin-bottom: 0px;\n    margin-left: -10px;\n    text-transform: capitalize;\n  }\n\n  & > div {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #3a645c;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 2px 4.5px 2px 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  display: flex;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 0;\n\n  & > .ant-modal-content {\n    border-radius: 3px;\n    max-height: 100vh;\n    overflow: hidden;\n  }\n\n  & .ant-modal-close-x {\n    font-size: 11px;\n  }\n\n  .ant-modal-body {\n    max-height: 100vh;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px 20px 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n  flex: 1;\n  overflow: auto;\n\n  & > * {\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n    margin: 0;\n  }\n\n  .ant-skeleton-title {\n    margin: 0 0 8px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  outline: none;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n\n  & > .ant-skeleton-button {\n    border-radius: 4px;\n    height: 74px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  width: 100%;\n  max-height: 100vh;\n  gap: 0px;\n  & > div {\n    width: 100%;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}





var CompanyLabelContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f6c618c-0"
})(_templateObject());
var DataField = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-f6c618c-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var BaseContainerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].downgray */ .Z.downgray);
var BaseContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6c618c-2"
})(_templateObject3(), BaseContainerStyle);
var TableContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].fieldset.withConfig */ .ZP.fieldset.withConfig({
    componentId: "sc-f6c618c-3"
})(_templateObject4(), BaseContainerStyle);
var CompanyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-4"
})(_templateObject5(), BaseContainerStyle);
var SymbolAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f6c618c-5"
})(_templateObject6());
var LabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-f6c618c-6"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary);
var LabelDayTrade = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(LabelWrapper).withConfig({
    componentId: "sc-f6c618c-7"
})(_templateObject8());
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-8"
})(_templateObject9());
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6c618c-9"
})(_templateObject10());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6c618c-10"
})(_templateObject11());
// Company
var CompanyTextSkeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-11"
})(_templateObject12());
var CompanyButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-f6c618c-12"
})(_templateObject13());
var CompanySkeletonBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Button */ .Z.Button).attrs({
    active: true
}).withConfig({
    componentId: "sc-f6c618c-13"
})(_templateObject14());
var ModalContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f6c618c-14"
})(_templateObject15());


/***/ }),

/***/ 69836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lw": function() { return /* binding */ BadgeLabelWrapper; },
  "W2": function() { return /* binding */ Container; },
  "dk": function() { return /* binding */ Description; },
  "CC": function() { return /* binding */ IconArrow; },
  "Qu": function() { return /* binding */ ModalIndicatorBar; },
  "L$": function() { return /* binding */ MultiplierChip; },
  "cF": function() { return /* binding */ MultiplierContainer; },
  "Nj": function() { return /* binding */ NotationBadgeContainer; },
  "H_": function() { return /* binding */ NotationBar; },
  "HC": function() { return /* binding */ NotationList; },
  "MC": function() { return /* binding */ NotationPopoverContainer; },
  "GU": function() { return /* binding */ NotationTag; },
  "LA": function() { return /* binding */ PopoverBadgeContainer; },
  "H9": function() { return /* binding */ PopoverIndicator; },
  "o7": function() { return /* binding */ TradingLimitBadge; }
});

// UNUSED EXPORTS: BadgeLabelDayTrade

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Modal.js
var Modal = __webpack_require__(16368);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./src/@deprecated-ui/notation/Tag.js
var Tag = __webpack_require__(11913);
;// CONCATENATED MODULE: ./src/@deprecated-ui/notation/index.js
// eslint-disable-next-line import/prefer-default-export


// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Notation/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 36px;\n      width: 100%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 2px;\n  margin: auto;\n  padding: 20px 28px;\n  width: 350px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  font-size: 14px;\n  line-height: 15px;\n  padding-bottom: 10px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: scroll;\n  max-height: 300px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: rgba(235, 160, 49, 0.03);\n  cursor: pointer;\n  height: 38px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: unset;\n    justify-content: center;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    text-align: center;\n    width: unset;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 20px;\n    width: 20px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    width: 22.8px;\n    cursor: unset;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    width: 12px;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-right: 0;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin-bottom: 2px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: #fef4e8;\n  border: 1px solid #f5931b;\n  color: #f5931b;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  font-family: ProximaNovaBd;\n\n  ",
        "\n\n  ",
        "\n  > .notation-label__icon {\n    height: 12px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  background-color: #f5f0ff;\n  padding: 2px 4.5px 2px 2px;\n  height: 16px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ], [
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-close {\n    color: rgba(0, 0, 0, 0.43);\n\n    .ant-modal-close-x {\n      font-size: 14px;\n      height: 48px;\n      line-height: 48px;\n      width: 48px;\n\n      .ant-modal-close-icon {\n        color: rgba(0, 0, 0, 0.43);\n        height: 14px;\n        width: 14px;\n\n        > svg {\n          fill: inherit;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: unset !important;\n  min-width: 12px;\n  height: 12px;\n  gap: 2px;\n  border: 1px solid #f5931b;\n  border-radius: 2px;\n  background-color: #fef4e8;\n  padding: 0 2.5px;\n  color: #f5931b;\n  font-size: 9px;\n  line-height: normal;\n  font-family: var(--font-regular);\n  margin: 0;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 8px;\n  position: relative;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #8277f8;\n  border-radius: 2px;\n  height: 16px;\n  padding: 0 4.5px 0 2px;\n  color: #8277f8;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #94b041;\n  font-family: var(--font-regular);\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.2px;\n  color: #94b041;\n  border-radius: 2px;\n  background: #f2f6e8;\n  text-align: center;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  padding: 0 2px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 375px;\n  border: 1px solid #dadada;\n  padding: 20px;\n  border-radius: 4px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}








var Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-61468579-0"
})(_templateObject1(), color/* default.light */.Z.light, // @ts-expect-error
function(param) {
    var isFullsize = param.isFullsize;
    return isFullsize && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
});
var Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-61468579-1"
})(_templateObject2(), color/* default.component */.Z.component);
var NotationList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-2"
})(_templateObject3());
var NotationBar = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-61468579-3"
})(_templateObject4());
var notationTagVariant = {
    indicator: (0,styled_components_browser_esm/* css */.iv)(_templateObject5()),
    notation: (0,styled_components_browser_esm/* css */.iv)(_templateObject6()),
    uma: (0,styled_components_browser_esm/* css */.iv)(_templateObject7()),
    x: (0,styled_components_browser_esm/* css */.iv)(_templateObject8())
};
var NotationTag = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-61468579-4"
})(_templateObject11(), // @ts-expect-error
function(param) {
    var type = param.type;
    return notationTagVariant[type];
}, // @ts-expect-error
function(param) {
    var isNotationBadges = param.isNotationBadges;
    return isNotationBadges ? (0,styled_components_browser_esm/* css */.iv)(_templateObject9()) : (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
});
var BadgeLabelWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "center",
    px: "5px",
    py: "2px",
    ml: "5px"
}).withConfig({
    componentId: "sc-61468579-5"
})(_templateObject12(), color/* default.primary */.Z.primary);
var BadgeLabelDayTrade = (0,styled_components_browser_esm/* default */.ZP)(BadgeLabelWrapper).withConfig({
    componentId: "sc-61468579-6"
})(_templateObject13());
var IconArrow = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* default */.Z).withConfig({
    componentId: "sc-61468579-7"
})(_templateObject14(), color/* default.yellowSea */.Z.yellowSea, color/* default.yellowSea */.Z.yellowSea);
var ModalIndicatorBar = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.Z).attrs({
    maskStyle: {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
}).withConfig({
    componentId: "sc-61468579-8"
})(_templateObject15());
var PopoverIndicator = (0,styled_components_browser_esm/* default */.ZP)(Popover/* default */.ZP).attrs({
    overlayInnerStyle: {
        border: "1px solid ".concat(color/* default.gainsboro */.Z.gainsboro)
    }
}).withConfig({
    componentId: "sc-61468579-9"
})(_templateObject16());
var NotationBadgeContainer = (0,styled_components_browser_esm/* default */.ZP)(Tag/* default */.Z).withConfig({
    componentId: "sc-61468579-10"
})(_templateObject17());
var NotationPopoverContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-11"
})(_templateObject18());
var MultiplierContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-12"
})(_templateObject19());
var MultiplierChip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-13"
})(_templateObject20());
var TradingLimitBadge = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-14"
})(_templateObject21());
var PopoverBadgeContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61468579-15"
})(_templateObject22());



/***/ }),

/***/ 59359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ exodusApiInstance; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusApiInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    disabledErrorAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};


/***/ }),

/***/ 97454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useEmittenInfoStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/emitten.ts




var getEmittenInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", exodus/* exodusApiInstance.disabledErrorAlert.get */.l.disabledErrorAlert.get(apiEndpoint/* emittenEndpoint.emittenInfo */.CI.emittenInfo(symbol)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEmittenInfo(symbol) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts






var initialState = {
    data: {},
    isLoading: false
};
var useEmittenInfoStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadEmittenInfo: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getEmittenInfo(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetEmittenInfo: function() {
            set(initialState);
        },
        updateEmittenInfo: function(newData) {
            set(function(state) {
                return {
                    data: (0,_object_spread/* default */.Z)({}, state.data, newData)
                };
            });
        }
    });
});
/* harmony default export */ var stores_useEmittenInfoStore = (useEmittenInfoStore);


/***/ })

}]);